<template>
    <header class="header-component">
        <div class="container">
            <div class="header-content">
                <h1 class="main-title">GUT FÜR BRUCHKÖBEL</h1>
                <p class="election-date">Bürgermeisterwahl am 26.10.25</p>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'HeaderComponent'
}
</script>